// 客户端图像处理 —— canvas resize + center-crop 到正方形 PNG
//
// 用于头像上传: 浏览器读 File → 解码到 ImageBitmap → 居中裁正方形 →
// 缩到 256×256 → toDataURL("image/png")
//
// 不依赖第三方库, 纯 Web Crypto / Canvas / FileReader。

const SIZE = 256;

export async function fileToAvatarDataUrl(file: File): Promise<string> {
  if (!file.type.startsWith("image/")) {
    throw new Error("仅支持图片文件");
  }
  if (file.size > 8 * 1024 * 1024) {
    throw new Error("图片太大 (> 8 MB), 请先压缩");
  }
  // 解码到 bitmap
  const bitmap = await createImageBitmap(file);
  try {
    // 居中裁剪正方形
    const side = Math.min(bitmap.width, bitmap.height);
    const sx = Math.floor((bitmap.width - side) / 2);
    const sy = Math.floor((bitmap.height - side) / 2);

    const canvas = document.createElement("canvas");
    canvas.width = SIZE;
    canvas.height = SIZE;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("canvas 不可用");
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(bitmap, sx, sy, side, side, 0, 0, SIZE, SIZE);

    return canvas.toDataURL("image/png");
  } finally {
    bitmap.close?.();
  }
}
